export default {"src":"/_next/static/media/dollar-shiny.569c5921.svg","height":322,"width":313,"blurWidth":0,"blurHeight":0};